import { motion } from "framer-motion";

export function XpBar({ value, max, className = "" }) {
  const pct = max > 0 ? Math.min(100, Math.round((value / max) * 100)) : 100;
  return (
    <div className={`w-full h-3 rounded-full bg-zinc-800/80 overflow-hidden ${className}`} data-testid="xp-bar">
      <motion.div
        className="h-full rounded-full gold-gradient xp-shimmer"
        initial={{ width: 0 }}
        animate={{ width: `${pct}%` }}
        transition={{ duration: 0.9, ease: "easeOut" }}
      />
    </div>
  );
}
